import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useRemoteClientGet } from '../../configs/http-client'
import { CatchMessageError } from '../../remote/catch-message-error'
import { useLocalStorage } from '../../remote/local-storage'
import { convertParamsToJson, useCashfitParams } from '../hooks/use-params'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select'

export function SelectUnit() {
  const { useSetLocalStorageUnit, getUnitId } = useLocalStorage()
  const [params] = useSearchParams()
  const { setParams } = useCashfitParams(convertParamsToJson(params))
  const { remoteClientGet } = useRemoteClientGet()
  const [data, setData] = useState<any>(null)

  const [selected, setSelected] = useState(getUnitId()?.toString() || '')

  const onChangeValue = (data: any) => {
    setSelected(data)
    useSetLocalStorageUnit(data)
    setParams({ unit: data })
  }

  useEffect(() => {
    //console.log(getUnitId().toString())
    remoteClientGet('/unidades/usuario', { page: 0, size: 1000, sortParam: 'id', order: 'desc' })
      .then((response) => {
        setData(response?.data?.data)

        if (response?.data?.data?.length > 0) {
          const unitId = response?.data?.data[0]?.id?.toString()
          setSelected(response?.data?.data[0]?.id?.toString())
          setParams({ unit: unitId })
          useSetLocalStorageUnit(unitId)
          return
        }

        setSelected(getUnitId()?.toString())
        setParams({ unit: getUnitId()?.toString() })
      })
      .catch(CatchMessageError)
  }, [])

  return (
    <Select onValueChange={onChangeValue} value={selected}>
      <SelectTrigger className="">
        <SelectValue placeholder="Selecione" className="w-full" />
      </SelectTrigger>
      <SelectContent>
        {data &&
          data.map((item: any) => (
            <SelectItem key={item.id} value={item.id.toString()}>
              {item.nomeFantasia}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  )
}
